import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import PageTitle from "../../../common/page-title/index";
import PccSettingsForm from './ppc-settings-form'
import {getPpcSettings} from '../../../../actions/ppc';

import './styles.css'

class PpcSettings extends Component {

  constructor(props){
    super(props);
  }

  componentWillMount() {
    this.props.dispatch(getPpcSettings());
  }

  render(){
    return(
      <Grid bsClass="container" fluid className="ppc-settings">
        <Row>
          <Col lg={12}>
            <PageTitle>Prepaid card settings</PageTitle>
            <PccSettingsForm />
          </Col>
        </Row>
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetched: state.brands.fetched,
    fetching: state.brands.fetching,
  };
};

export default connect(mapStateToProps)(PpcSettings);



// WEBPACK FOOTER //
// ./src/components/admin/ppc/settings/index.jsx